<script lang="ts">
	// The design system's Caption (design/components/surfaces/Caption.jsx, V1):
	// the words of one scene, drawn by the Help player over or under the video,
	// never burnt into the recording, so they read at any size, a 375 px phone
	// included. Over the frame (`over`, the default) it sits on --surface-caption:
	// the video shows through behind the words, so the viewer never loses the
	// screen under them, while the words stay solid. Under the frame (the narrow
	// player) nothing moves behind it, so it is the solid emphasis surface. Both
	// invert with the theme, so it reads in Light and Dark alike.
	//
	// Two lines at most. The clamp is a guard, not the layout: words that need
	// a third line belong to a second scene. Arabic runs right to left, and the
	// recording keeps its numbers in order.

	interface Props {
		text: string;
		size?: 'md' | 'lg';
		/** Drawn over the video, so the frame shows through. False under it. */
		over?: boolean;
		dir?: 'ltr' | 'rtl';
		lang?: string;
	}

	let { text, size = 'md', over = true, dir, lang }: Props = $props();
</script>

<p class="caption {size}" class:see-through={over} {dir} {lang}>{text}</p>

<style>
	.caption {
		margin: 0;
		max-inline-size: min(100%, 44em);
		padding: var(--space-2) var(--space-4);
		background: var(--surface-invert);
		color: var(--on-ink);
		border-radius: var(--radius-input);
		font-size: var(--text-base);
		font-weight: 600;
		line-height: 1.45;
		text-align: center;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		overflow: hidden;
		text-wrap: balance;
	}

	/* Two classes, so it wins over the solid ground wherever it sits. */
	.caption.see-through {
		background: var(--surface-caption);
	}

	.lg {
		font-size: var(--text-h4);
	}
</style>
